<app-modal-header
  text="{{ 'TDRAW.MODAL.SITAC_SELECTOR.TITLE' | translate }}"
  (closeAction)="onClose()"
></app-modal-header>

<div class="body">
  <tdraw-sitac-selector (elementSelected)="onSubmit($event)"> </tdraw-sitac-selector>
</div>
